<template>
    <div class="layout">
        <div class="header">
                <div class="app-name">
                    <span>🌊</span>
                    <span>{{title}}</span>
                </div>
                <div class="extra">
                    <div class="menu">
                        <div v-for="item in menu" :key="item.path">
                            <div v-if="item.children && item.children.length > 0">
                                <a-dropdown overlayClassName="dropdown">
                                    <a style="display: inline-block" :class="isActivePath(item.path) ? 'active' : ''" >
                                        {{ item.name }}
                                    </a>
                                    <div slot="overlay" style="background-color:rgba(10, 14, 39, 0.9); padding: 12px 16px">
                                        <div v-for="element in item.children" :key="element.id">
                                            <router-link :to="element.path" style="line-height: 2em">
                                                {{element.name}}
                                            </router-link>
                                        </div>
                                    </div>
                                </a-dropdown>
                            </div>
                            <router-link v-else :to="item.path" style="display: inline-block" :class="isActivePath(item.path) ? 'active' : ''">
                                {{ item.name }}
                            </router-link>
                        </div>
                    </div>
                    <UserInfo/>
                </div>
        </div>
        <div>
            <BackgroundAnimation  :particleCount="30"/>
            <router-view></router-view>
        </div>
        <MapTools v-if="curPath === '/'"/>
    </div>
</template>
<script>
import MapTools from "@/components/map-tools";
import UserInfo from "./components/user-info.vue";
import {fetchUserPermissionList} from "@/api/login";
import {fetchList} from "@/api/setting/menu";
import {mapActions, mapMutations} from "vuex";
import BackgroundAnimation from '@/components/water-affairs-style/backgroundAnimation.vue';
export default {
    components: {
        MapTools,
        UserInfo,
        BackgroundAnimation
    },
    data() {
        return {
            title: '盱眙网数达智慧管网平台',
            menu: [],
            allMenu: [],
            menuByTree: [],
            curPath: this.$route.path,
        };
    },
    watch: {
        "$route.path"(newV) {
            this.curPath = newV;
        },
    },
    created() {
        this.title = localStorage.getItem('title') || '盱眙网数达智慧管网平台'
    },
    mounted() {
        const user = JSON.parse(window.localStorage.getItem("user"));

        fetchUserPermissionList({id: user.id}).then((res) => {
            if (res && Array.isArray(res.permission)) {
                this.permission = res.permission;
                this.setPermission(this.permission);

                fetchList().then((res) => {
                    console.log("res", res);
                    if (Array.isArray(res)) {
                        this.allMenu = res;
                        this.getUserMenu(this.allMenu, this.permission);
                    }
                });
            }
        });

        this.getDataDict();
    },

    methods: {
        ...mapMutations("auth", ["setPermission", "setMenu"]),
        ...mapActions("setting", ["getDataDict"]),

        isActivePath(path) {
            if (path === "/") {
                return this.curPath === path;
            } else {
                return this.curPath.includes(path);
            }
        },
        // getUserMenu() {
        getUserMenu(menu, permission) {
            const resultList = [];
            menu.forEach((item) => {
                const result = permission.find(
                    (element) => element.code === item.permission
                );
                if (result) {
                    resultList.push(item);
                }
            });

            const result = resultList
                .filter((item) => item.status === 1 && item.pid === "0")
                .sort((x, y) => {
                    if (x.sort < y.sort) {
                        return -1;
                    } else if (x.sort > y.sort) {
                        return 1;
                    } else {
                        return 0;
                    }
                }); // 过滤出状态正常的菜单

            result.forEach((item) => {
                item.children = resultList.filter((element) => {
                    return element.pid === item.id;
                });
            });

            this.setMenu(result); //存到vuex中
            console.log("result", result);
            this.menu = result;
           
        },
    },
};
</script>
<style lang="less" scoped>
@font-face {
    font-family: YouSheBiaoTiHei;
    src: url("../assets/YouSheBiaoTiHei.ttf");
}

@bg-color: rgba(10, 14, 39, 0.9);
@theme-color: #00ff96;
@secondary-color: #00d4ff;
@text-color: #94a3b8;
@active-text: #00ff96;
@grid-color: rgba(0, 255, 150, 0.05);
@logout-color: #ff6b6b;

.layout {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow-x: hidden;

    /* 背景效果 - 保留原HTML中的渐变和网格效果 */
    &::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -2;
        background:
            radial-gradient(circle at 20% 80%, #1a3a52 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, #0f2847 0%, transparent 50%),
            radial-gradient(circle at 40% 40%, #162347 0%, transparent 50%);
    }

    &::after {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
        background-image:
            linear-gradient(@grid-color 1px, transparent 1px),
            linear-gradient(90deg, @grid-color 1px, transparent 1px);
        background-size: 50px 50px;
        animation: grid-move 20s linear infinite;
    }

    @keyframes grid-move {
        0% { transform: translate(0, 0); }
        100% { transform: translate(50px, 50px); }
    }
}

.header {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;
    height: 70px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 255, 150, 0.3);
    transition: all 0.3s ease;
    background-color: @bg-color;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 0 5%;

    .app-name {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 1.5vw;
        font-family: YouSheBiaoTiHei;
        background: linear-gradient(135deg, @theme-color, @secondary-color);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-decoration: none;

        span:first-child {
            font-size: 1vw;
        }
    }

    .menu {
        display: flex;
        align-items: center;
        margin-left: 80px;

        > div {
            display: flex;
            align-items: center;
        }

        a, router-link {
            color: @text-color;
            margin-right: 25px;
            font-size: 0.8vw;
            text-decoration: none;
            transition: all 0.3s ease;
            position: relative;
            height: 100%;
            display: flex;
            align-items: center;
            padding-bottom: 4px;

            &:hover, &.active {
                color: @active-text;
            }
        }

        .active {
            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 2px;
                background: linear-gradient(90deg, @theme-color, @secondary-color);
            }
        }
    }

    .extra {
        margin-left: auto;
        display: flex;
        align-items: center;
        gap: 15px;
    }
}

.body {
    flex: 1;
    padding-top: 60px;
    background-color: #0a0e27;
}

.dropdown {
    box-shadow: 0px 4px 5px 1px rgb(0 0 0 / 16%);
    border-radius: 0px 0px 4px 4px;
    background-color: @bg-color;
}

/* 用户信息组件样式 - 适配Vue组件结构 */
.user-info {
    display: flex;
    align-items: center;
    gap: 10px;

    .user-avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: linear-gradient(135deg, @theme-color, @secondary-color);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
    }

    .logout-btn {
        color: @text-color;
        text-decoration: none;
        font-size: 14px;
        transition: color 0.3s ease;

        &:hover {
            color: @logout-color;
        }
    }
}
</style>
